import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

function getScoreColor(score) {
    if (score >= 80) {
        return '#43ac6a';
    } else if (score >= 40 && score < 80) {
        return '#e99002';
    } else {
        return '#f04124';
    }
}
function getConnection(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px' }}>
                    <Typography variant="h6">
                        Connection  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br />
							The language of Connection means you are interested in more than just working for someone.  Trust is built by getting to know your leader as a person and them getting to know you.  A leader who works to build a personal relationship with you helps you build a better working relationship.  When you feel understood by and personally connected to your leader it boosts your trust in them, loyalty, and desire to go to bat for them.  You are more excited to show up when your boss knows you as a person, and you feel you know them.
                        </p>

						<p>
                            <b>How You Tend to Lead</b>
                            <br />
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to value communicating with respect, warmth, and consideration of others.  You tend to build meaningful, personal relationships with the people you lead. You may enjoy your work relationships more when you feel a personal connection with your people.
                        </p> 
                        <p>
							But when your leader is all business who takes little interest in you as a person, you may start to feel used, just a cog in a system for their purpose. When your leader reveals little about themselves or is distant and reserved, you may struggle to trust them and become less motivated to execute tasks for them.
						</p>
                        <p>
                            <b>If You Manage Someone with This Leadership Language</b>
                            <br />
							Read the description above carefully to understand their motivations.  Then have a conversation with them about what Connection means for them.  Use the questions below and their answers to find ways to speak in their language.
                        </p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fit? What doesn't?
								</li>
								<li>
								Ask, "In what ways is a personal connection helpful for you in your work? Do you feel you're getting what you need here?"
								</li>
								<li>
								If not, ask, "Are there any specific ways you can think of that might help me create more meaningful connections with you or the team?"
								</li>
							</ul>
                        </p>
                    </Typography>
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="connection" src="/connection.png" />
            </Grid>
        </Grid>
    );
}
function getMentoring(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px' }}>
                    <Typography variant="h6">
                        Mentoring  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br />
							When Mentoring is a primary language, you appreciate a leader who is hands on, who has more experience or subject matter expertise.  You appreciate a leader who is a good teacher and guides you carefully in your work.  You generally like to learn, growth is important to you.  It means a lot when your leader gets this.  It also helps to know if you make a mistake or have a question, you’ve got a backstop.  When you feel your leader is investing in your development and shows you ways to grow, it increases your enthusiasm and engagement.
                        </p>

						<p>
                            <b>How You Tend to Lead</b>
                            <br />
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to invest in people development.  You don’t just think about getting the job done, you want to know how your people are growing and reaching their potential too. You may enjoy coaching others to greater success.
                        </p>

                        <p>
						If your leader doesn’t seem interested in helping you grow or develop, you will feel mostly abandoned and adrift.  Or if your leader doesn’t seem to know what they are doing and can’t help you develop, you may resent the fact they get paid more than you or you may even resist their direction and input. 
                        </p>
                        <p>
                            <b>If You Manage Someone with This Leadership Language</b>
                            <br />
							Read the description above carefully to understand their motivations.  Then have a conversation about what Mentoring means for them.  Use the questions below and their answers to find ways to speak in their language.
						</p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fits them? What doesn't?
								</li>
								<li>
								Ask, "What does mentoring mean to you?  Are you getting the kind of mentoring, growth, or development you need?"
								</li>
								<li>
								If they aren't getting what they need, ask, "What could I do to help you experience the mentoring, growth, or development you are looking for?"
								</li>
							</ul>
                        </p>
                    </Typography>
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="mentoring" src="/mentoring.png" />
            </Grid>
        </Grid>
    );
}
function getPurpose(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px' }}>
                    <Typography variant="h6">
                        Purpose  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br />
							When Higher Purpose scores high, it means you are mission-driven.  You are motivated by a cause larger than financial performance or excellence in work.  Making a difference in the world or the lives of people matters to you even in a commercial enterprise.  When your leader shares this commitment, or at least understands how important it is to you, that is fuel in your tank.  When your leader links your daily work to a larger mission and inspires others to do the same, it boosts your trust in them and your performance.

                        </p>
						<p>
                            <b>How You Tend to Lead</b>
                            <br />
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to be interested in WHY the organization exists beyond just making money or solving problems.  You are likely connected to your own higher purpose and want others to experience the same connection.  Inspiring others with a big and meaningful vision comes naturally to you.
                        </p>
                        <p>
						If your leader shows little interest in higher purpose and is only focused on making money or work performance, you will feel uninspired and may lose heart.  You may see your leader as myopic or even small minded.  This could lead you to search for more meaningful and purpose-driven work environments.
						</p>
                        <p>
                            <b>If You Manage Someone with This Leadership Language</b>
                            <br />
							Read the description above carefully to understand their motivations.  Then have a conversation about what Higher Purpose means for them.  Use the questions below and their answers to find ways to speak in their language.
						</p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fit? What doesn't
								</li>
								<li>
								Ask, "What makes your work meaningful? Do you have a sense of your purpose? Are you satisfied with the organizations sense of purpose?"	
								</li>
								<li>
								If they aren't getting what they need, ask, "Is there anything I can do to help make your work more meaningful?"
								</li>
							</ul>
                        </p>
                    </Typography>
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="purpose" src="/purpose.png" />
            </Grid>
        </Grid>
    );
}
function getRecognition(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px' }}>
                    <Typography variant="h6">
                        Recognition  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br />
							For some people, words speak louder than actions. If Recognition is your leadership language, hearing your manager or coworker give you verbal recognition is wind in your sails. Hearing the words, “you did a great job” are important. Even more powerful? When your leader shares specifically what they saw you achieve or contribute and what it meant to them or the team. This makes you feel seen and appreciated. You work hard and you don’t require much from a leader, just some verbal acknowledgement is all it takes to get you motivated.  
                        </p>

						<p>
                            <b>How You Tend to Lead</b>
                            <br />
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to inspire your team and coworkers with verbal encouragement. You use a variety of verbal means to publicly and privately celebrate their success and contributions. Sometimes this means you tend to avoid critical conversations where clear feedback for improvement are required.
                        </p> 
                        <p>
						At the same time, if your leader is stingy with verbal praise, this will create resentment and frustration. You’ll feel unappreciated. If your leader makes thoughtless or overly critical comments towards you, that’s a breach of trust and you will consider work elsewhere.                       
						</p>
						<p>
                            <b>If You Manage Someone with This Leadership Language</b>
                            <br />
							Read the description above carefully to understand their motivations. Then have a conversation about what Recognition means for them. Use the questions below and their answers to find ways to speak in their language.
						</p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fit? What doesn't?
								</li>
								<li>
								Ask, "What do you feel most proud of recently in your work? Are there any ways you think I could recognize people better?"	
								</li>
								<li>
								Ask, "When I give feedback for improvement, is there any way I could do that more effectively or in a way that it is easier to receive?"
								</li>
							</ul>
                        </p>
                    </Typography>
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="recognition" src="/recognition.png" />
            </Grid>
        </Grid>
    );
}

function getProximity(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px'}}>
                    <Typography variant="h6">
                        Proximity  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>   
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br/>
							When your primary leadership language is Proximity, you want to see your leader meaningfully present in the organization.  When a leader is accessible and visible, you are more likely to trust their decisions are informed by what’s happening on the ground.  It helps you do your job when you can see their job.  It’s also important your leader can see you.  This communicates solidarity and support when your leader is interacting with you and sees your contribution. This is as much about a leader’s availability, visibility, and access, as it is physical or virtual presence..
                        </p>
						<p>
                            <b>How You Tend to Lead</b>
                            <br/>
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to prioritize being in the office or accessible. You value having your finger on the pulse of what’s happening in the trenches. You might have an open-door policy (physical or virtual) or make a point of interacting with your people in their world. This is how you show them you can see what challenges they are up against.  							
						</p>
                        <p>
						However, when your leader is invisible for long periods of time, difficult to access, or doesn’t seem to understand your role and work, you will lose trust in them.  Their credibility falls off a cliff for you.  You will doubt their decisions are informed by what’s actually happening in the business and no longer buy-in to their direction.                        
						</p>
						<p>
                            <b>If You Manage Someone with This Leadership Language</b>
                            <br/>
							Read the description above carefully to understand their motivations.  Then have a conversation about what Proximity means for them.  Use the questions below and their answers to find ways to speak in their language
                        </p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fit? What doesn't?
								</li>
								<li>
								Ask, "Are you getting the amount of proximity or visibility you want from me?  Do I have the right visability or proximity to you or your work?"
								</li>
								<li>
								If they aren't getting what they need, ask, "What could help you have more visibility or proximity with me? What might help me have the right visibility or proximity to you or your work? 
								</li>
							</ul>
                        </p>
                    </Typography> 
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="proximity" src="/proximity.png" />
            </Grid>
        </Grid>        
    );
}
function getEmpowerment(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px'}}>
                    <Typography variant="h6">
                        Empowerment  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>   
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br/>
							When you score high in Empowerment, you likely feel you are stronger in your domain than your leader.  Perhaps you are a subject matter expert in an area they are not.  Whatever the case, you prefer being given the power to do your job without having to get all your decisions approved first.  That means you appreciate when your leader grants you authority that matches your responsibility. You require less guidance to do your job well and appreciate a leader who understands this.
                        </p>

						<p>
                            <b>How You Tend to Lead</b>
                            <br/>
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you may prefer leading people who are already operating at their potential. Helping them grow isn't your first priority, instead you may be focused on overcoming big obstacles. As a result, you want experts in their domain and are ready to give them proper authority to execute their work without needing to give much guidance.  
						</p>

                        <p>
						However, if your manager wants to engage in development conversations to help you improve, this is only effective if you see your manager as credible in your area.  Otherwise, you will be dismissive or possibly annoyed by their efforts to mentor you.  You may humor them because you have to, but ultimately you will likely lose respect for your leader.						
						</p>
						<p>
                            <b>If You Manage Someone with This Leadership Language</b>
                            <br/>
							Read the description above carefully to understand their motivations.  Then have a conversation about what Empowerment means for them.  Use the questions below and their answers to find ways to speak in their language.                        
						</p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fits them? What doesn't?					
								</li>
								<li>
								Ask, "Do you feel you have the appropriate authority and empowerment to do your job?"
								</li>
								<li>
								If they aren't getting what they need, ask, "What could I do to help you experience the autonomy you want? 								
								</li>
							</ul>
                        </p>
                    </Typography> 
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="empowerment" src="/empowerment.png" />
            </Grid>
        </Grid>        
    );
}

function getBoundaries(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px'}}>
                    <Typography variant="h6">
                        Boundaries  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>   
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br/>
							You tend to prefer a leader who is focused on work when you're at work.  You value personal boundaries and don’t need a close friendship with your boss or others at work in order to feel motivated.  In fact, it may feel better not to have one.  You also may prefer when your leader has boundaries around their personal life.  That means they are selectively disclosing, which allows everyone to focus more on the work than on life outside of work.  You appreciate a leader who respects your boundaries.  It may help you feel more comfortable and respected in the work place.                        
						</p>

						<p>
                            <b>How You Tend to Lead</b>
                            <br/>
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to prefer a healthy separation between your work and personal life. You are here to work and lead others to the same, not develop close friendships with your employees. You likely appreciate the efficiency and clarity this brings to the work with your team.						
						</p>
                        <p>
						But when your leader engages in conversations about your family, your vacation, or your weekend on working time, you may find yourself polite but irritated or uncomfortable.  It may feel like your boss is wasting your time and you want to get to the business of work.                             
						</p>
						<p>
						<b>If You Manage Someone with This Leadership Language</b>
                            <br/>
							Read the description above carefully to understand their motivations.  Then have a conversation with them about what Boundaries means for them.  Use the questions below and their answers to find ways to speak in their language.                        
						</p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fit? What doesn't?								
								</li>
								<li>
								Ask, "What boundaries do you most appreciate at work?  Do you feel like the boundaries that matter to you are being respected?"
								</li>
								<li>
								If the answer is no, ask, "What are the best ways I can help respect your boundaries?"
								</li>
							</ul>
                        </p>
                    </Typography> 
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="boundaries" src="/boundaries.png" />
            </Grid>
        </Grid>        
    );
}

function getFeedback(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px'}}>
                    <Typography variant="h6">
                        Feedback  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>   
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br/>
							If Feedback is your leadership language, hearing your manager or coworker tell you what a great job you did is fine, but it's not a big motivator. You may even feel suspicious if a leader frequently tells you all the things you do well, and rarely suggests things that could be better. Instead you likely prefer feedback with a focus on areas of improvement. This often feels more actionable and a better use of time than listening to accolades. Perhaps you are motivated more by a challenge or a leader who is focused on exposing the gaps in your performance as a way to help you get better.                           
						</p>
						<p>
                            <b>How You Tend to Lead</b>
                            <br/>
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to you want the best results from your people. You are more likely to use constructive or even critical feedback to get that. You're approach could be summarized as "No news is good news.  If you don't hear from me, you're doing fine. Otherwise, I'll let you know what needs to change."						</p>
                        <p>
						If your leader only gives you rosey accolades and rarely any actionable feedback, you may begin to doubt whether he or she is worth following.  This could lead to a loss of respect in your manager or perhaps even suspicion about what is behind their "nice" words.                              
						</p>
						<p>
						<b>If You Manage Someone with This Leadership Language</b>
                            <br/>
							Read the description above carefully to understand their motivations.  Then have a conversation about what Feedback means for them.  Use the questions below and their answers to find ways to speak in their language.                        
						</p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fit? What doesn't?
								</li>
								<li>
									Ask, "How do you experience recognition for good performance? Are you getting the right level of performance feedback to help you improve?"
								</li>
								<li>
								If they aren't getting what they need, ask, " When I give feedback for improvement, is there any way I could do that better?"								
								</li>
							</ul>
                        </p>
                    </Typography> 
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="feedback" src="/feedback.png" />
            </Grid>
        </Grid>        
    );
}

function getPerformance(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px'}}>
                    <Typography variant="h6">
                        Performance  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>   
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br/>
							When Performance is a high score, you typically appreciate a leader who is focused on excellence, results, and/or the pursuit of profit. Often this means you appreciate a leader who respects the limits of time and wants to get work done as efficiently as possible.  You may feel that the pursuit of meaning or purpose is a personal matter to be explored on your own time.  You don't need a leader to try and make work meaningful for you, or mobilize you to some higher organizational vision beyond solving problems and achieving results.                                 
						</p>

						<p>
                            <b>How You Tend to Lead</b>
                            <br/>
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to focus on optimal performance and achieving results.  This often means you are less concerned with whether the work is meaningful or if people enjoy what they do. For you, getting results is an end in itself and you likely expect a similar attitude from your people.						
						</p>
                        <p>
						If your leader too much spends time on creating culture, thinking about vision, higher purpose, or values, you may find yourself impatient. You may also feel frustrated that your valuable time is being taken up by conversations that don't feel immediately relevant to the performance goals you have set.  Overtime, you may feel you no longer fit in the organization.                              
						</p>
						<p>
						<b>If You Manage Someone with This Leadership Language</b>
                            <br/>
							Read the description above carefully to understand their motivations.  Then have a conversation about what Performance means for them.  Use the questions below and their answers to find ways to speak in their language.                        
						</p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fit? What doesn't								
								</li>
								<li>
								Ask, "Do you feel we are properly focused on achieving results? How do you relate to issues of purpose?  What makes work meaningful for you?"
								</li>
								<li>
								If they feel the focus isn't right, ask, "What could I do better to help you get what you need in terms of achieving the performance you're after? 								
								</li>
							</ul>
                        </p>
                    </Typography> 
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="performance" src="/performance.png" />
            </Grid>
        </Grid>        
    );
}

function getAutonomy(score) {
    return (
        <Grid container spacing={6} >
            <Grid item xs={12} sm={9} style={{ order: '1' }}>
                <div style={{ padding: '10px'}}>
                    <Typography variant="h6">
                        Autonomy  <b style={{ color: getScoreColor(score) }}>({score})</b>
                    </Typography>   
                    <Typography variant="subtitle1">
						<p>
                            <b>What You Want from a Leader</b>
                            <br/>
							In general, you don’t need to see or access your leader very often.  You tend to enjoy working independently and prefer high levels of autonomy.   You value being trusted and hope to extend that same trust upwards or across.  You are generally comfortable with a leader who has low visibility into your work and you may have a low need for line of sight into their work.  When a leader provides enough breathing room and margins to work when and how you like, it increases your appreciation of them and builds trust.                              
						</p>

						<p>
                            <b>How You Tend to Lead</b>
                            <br/>
							People often give to others in the way they want to receive. If that's true of you, then as a leader who scored high in this language, you tend to be a solo operator by nature. You prefer leading a self-managing team who can figure things out on their own and just get the job done. You may find being in a physical office where people have easy access to you a little invasive, distracting, or possibly overwhelming.  You tend to lead from a distance and prefer to work with others who can work independently from you.						</p>
                        <p>
						However, when your leader is asking for more information, reports, or check-ins than you think are necessary.  Or if your leader is physically entering your space more often than you like to talk about what you're working on, you may start to feel frustrated that your leader doesn't trust you.  You may experience this as micro-management, which will likely be very frustrating.                               
						</p>
						<p>
						<b>If You Manage Someone with This Leadership Language</b>
                            <br/>
							Read the description above carefully to understand their motivations.  Then have a conversation about what Autonomy means for them.  Use the questions below and their answers to find ways to speak in their language.                        
						</p>
                        <p>
							<ul>
								<li>
								Ask if the quiz results seem accurate to them. What seems to fit? What doesn't?								
								</li>
								<li>
								Ask, "Do you feel like I give you the level of autonomy you want or need?"
								</li>
								<li>
								If they aren't getting what they need, ask, "What could I do to help you experience the autonomy you want? 								
								</li>
							</ul>
                        </p>
                    </Typography> 
                </div>

            </Grid>
            <Grid item xs={12} sm={3} style={{ textAlign: 'center', order: '0' }}>
                <img style={{ maxWidth: '160px' }} alt="autonomy" src="/autonomy.png" />
            </Grid>
        </Grid>        
    );
}

function Text(props)  {
    switch (props.language) {
        case 'Proximity': 
            return getProximity(props.score);
        case 'Connection': 
            return getConnection(props.score);
        case 'Mentoring':
            return getMentoring(props.score);
        case 'Purpose':
            return getPurpose(props.score);
        case 'Recognition':
			return getRecognition(props.score);
		case 'Empowerment': 
			return getEmpowerment(props.score);
		case 'Boundaries': 
			return getBoundaries(props.score);
		case 'Feedback': 
			return getFeedback(props.score);
		case 'Performance': 
			return getPerformance(props.score);
		case 'Autonomy': 
			return getAutonomy(props.score);

        default:
            break;
    }
}
export default Text;